module.exports = __webpack_public_path__ + "img/hdst.3f0b8e5e.png";